// Make sure countryCodeToName is something like:
// { US: "United States", VN: "Vietnam", CA: "Canada", ... }
import { Avatar, List } from "antd";
import countryCodeToName from "../../../../../const/countryCodeToName";

export const ArrivalList = (props) => {
  const { arrivalList } = props;
  return (
    <List
      dataSource={arrivalList}
      renderItem={(item) => {
        // Find country code by comparing the string
        const countryCode = Object.keys(countryCodeToName).find(
          (code) => countryCodeToName[code] === item.guestNationality
        );

        return (
          <List.Item>
            <List.Item.Meta
              avatar={
                <Avatar
                  src={
                    countryCode
                      ? `https://flagcdn.com/h240/${countryCode.toLowerCase()}.png`
                      : undefined
                  }
                  alt={item.guestNationality}
                />
              }
              title={`Booking ID: ${item.bookingId}`}
              description={`${item.guestName} (${item.guestNationality})`}
            />
            <div>
              Rooms: <b>{item.totalRooms || 0}</b>, &nbsp; Adults:{" "}
              <b>{item.adults || 0}</b>, &nbsp; Children:{" "}
              <b>{item.children || 0}</b>
            </div>
          </List.Item>
        );
      }}
    />
  );
};
